import { Container, Typography } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';

import { RequireRole } from 'app/components/require-role';
import { Role } from 'app/constants/role';
import { SeamStatus } from 'app/constants/seam-status';
import { RootState } from 'app/store';

import { RequestTable } from './request-table';
import { selectRoles } from '../auth/auth.slice';

interface DashboardProps {
    // redux Props
    roles: Record<string, boolean>;
}

class Dashboard extends React.Component<DashboardProps> {
    public render() {
        return (
            <div>
                <Container maxWidth={false} className='mt-3'>
                    <Typography variant='body1'>
                        Click on a row to expand request details; click on title to open (holding Ctrl/Cmd/Middle Mouse
                        Click opens in new window) .
                    </Typography>
                    <RequireRole roles={[Role.TUNER, Role.SEAM_MANAGER]}>
                        <Typography variant='h6'>In-Progress: Patterns{/* & Labeling*/}</Typography>
                        <RequestTable filter={{ status: [SeamStatus.TUNE, SeamStatus.LABEL], my: true }} />
                    </RequireRole>
                    <RequireRole roles={[Role.SEAM_MANAGER]}>
                        <Typography variant='h6' className='mt-2'>
                            {' '}
                            For Review{' '}
                        </Typography>
                        <RequestTable filter={{ status: SeamStatus.REVIEW, my: true }} />
                    </RequireRole>
                    <RequireRole roles={[Role.QA_MANAGER]}>
                        <Typography variant='h6' className='mt-2'>
                            {' '}
                            QA{' '}
                        </Typography>
                        <RequestTable filter={{ status: [SeamStatus.QA, SeamStatus.PREPROD], my: true }} />
                    </RequireRole>
                    <RequireRole roles={[Role.QA_MANAGER]}>
                        <Typography variant='h6' className='mt-2'>
                            Prod QA{' '}
                        </Typography>
                        <RequestTable filter={{ status: [SeamStatus.PROD_QA], my: true }} />
                    </RequireRole>
                    <RequireRole roles={[Role.SEAM_MANAGER]}>
                        <Typography variant='h6' className='mt-2'>
                            {' '}
                            Closed{' '}
                        </Typography>
                        <RequestTable filter={{ status: SeamStatus.CLOSED, my: true }} />
                    </RequireRole>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    roles: selectRoles(state),
});

const connected = connect(mapStateToProps)(Dashboard);

export { connected as Dashboard };
